import { render, staticRenderFns } from "./view.html?vue&type=template&id=e13a9ee4&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=e13a9ee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13a9ee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e13a9ee4')) {
      api.createRecord('e13a9ee4', component.options)
    } else {
      api.reload('e13a9ee4', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=e13a9ee4&scoped=true&", function () {
      api.rerender('e13a9ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnpackgameInstanceItem/RewardModal/index.vue"
export default component.exports